import { datesNumToName } from "./dateHelpers";
import { formatNumToTime } from "./timeHelpers";


const getDates = (actualPairingDates: any) => {
    let dateObject = {};
    let dates = actualPairingDates.map(f => new Date(`${f}T00:00:00`));
    let monthKeys = actualPairingDates.map(f => new Date(`${f}T00:00:00`).getMonth()).filter((f, i, a) => a.indexOf(f) === i);  
    monthKeys.forEach(key => {
      dateObject[key] = dates.filter(f => f.getMonth() === key).map(f => f.getDate());
    });
    let monthArr: string[] = Object.keys(dateObject);
    // single sceanrio to handle when Dec and Jan month pairings show up
    // to show first Dec and then Jan Dates
    if(monthArr[0]==='0' && monthArr[1] && monthArr[1]==='11'){
      let jan: string = monthArr.shift() || "";
      monthArr.push(jan);
    }
    const datesString = monthArr.map((f,index) => index===0?`${datesNumToName(f, 1)} ${dateObject[f].join(', ')}`:`, ${datesNumToName(f, 1)} ${dateObject[f].join(', ')}`).reduce((a, b) => a + b, '');
    return datesString;
  };


export const getFormattedData = (pairingList) => {

    return pairingList.map(pairing => {
      return {
        pairingId:pairing.pairingId,
        days: pairing.days,
        credit: formatNumToTime(pairing.credit),
        route: pairing.flightSegments.map(s => `${s.segment} ${s.layOver ? formatNumToTime(s.layOver) : ''}`).reduce((a, b) => a + b, ''),
        onduty: formatNumToTime(pairing.onduty),
        offduty: formatNumToTime(pairing.offduty),
        hoursPerDay: formatNumToTime(pairing.hoursPerDay),
        expenses: "$"+((pairing.expenses) / 100).toFixed(2),
        dates: getDates(pairing.dates),
        tafb: formatNumToTime(pairing.tafb),
        eff: pairing.eff,
        fltNo: pairing.flightSegments.map((f, i, a) => {
            let fltDashed = f.fltNo.replace(',', '-');
            return a.length > 1 ? ((a.length - 1 !== i) ? `${fltDashed}, ` : `${fltDashed}`) : `${fltDashed}`;
          }).reduce((a, b) => a + b, ''),
        daycredit: formatNumToTime(pairing.daycredit),
        nightcredit: formatNumToTime(pairing.nightcredit),
        overseasCredit: formatNumToTime(pairing.overseasCredit),
        dhCredit: formatNumToTime(pairing.dhCredit),
        sectors: pairing.sectors,
        occurs: pairing.occurs,
        pairType: pairing.pairType,
      
      };
    });
  }

    export const getFormattedAllData = (dataList) => {
      let pairingList = [] as any;

      dataList.forEach( data => {
        data.pairinglist.forEach(pairing => {
          pairingList.push( {
            categoryName: data.categoryName,
            pairingId:pairing.pairingId,
            days: pairing.days,
            credit: formatNumToTime(pairing.credit),
            route: pairing.flightSegments.map(s => `${s.segment} ${s.layOver ? formatNumToTime(s.layOver) : ''}`).reduce((a, b) => a + b, ''),
            onduty: formatNumToTime(pairing.onduty),
            offduty: formatNumToTime(pairing.offduty),
            hoursPerDay: formatNumToTime(pairing.hoursPerDay),
            expenses: "$"+((pairing.expenses) / 100).toFixed(2),
            dates: getDates(pairing.dates),
            tafb: formatNumToTime(pairing.tafb),
            eff: pairing.eff,
            fltNo: pairing.flightSegments.map((f, i, a) => {
                 let fltDashed = f.fltNo.replace(',', '-');
                return a.length > 1 ? ((a.length - 1 !== i) ? `${fltDashed}, ` : `${fltDashed}`) : `${fltDashed}`;
              }).reduce((a, b) => a + b, ''),
            daycredit: formatNumToTime(pairing.daycredit),
            nightcredit: formatNumToTime(pairing.nightcredit),
            overseasCredit: formatNumToTime(pairing.overseasCredit),
            dhCredit: formatNumToTime(pairing.dhCredit),
            sectors: pairing.sectors,
            occurs: pairing.occurs,
            pairType: pairing.pairType,
          });
        })
      })
      return pairingList;
    }
  


  
